import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import userService from '../../services/userService'
import { Research } from '../../services/models'
import ResearchListComponent from '../../components/ResearchListComponent/ResearchListComponent'
import { Spin, Typography } from 'antd'

type Props = {}

const SearchPage: React.FC<Props> = () => {
  const [searchParams] = useSearchParams()
  const [items, setItems] = useState<Research[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [failed, setFailed] = useState<boolean>(false)

  const q = searchParams.get('q')

  // Зависимость именно [q], а не []: страница открыта всегда, когда клиент
  // ищет, поэтому второй запрос из шапки меняет только ?q= и не перемонтирует
  // компонент. С пустым массивом эффект запускался бы один раз, и клиент видел
  // бы результаты предыдущего запроса, не понимая почему.
  useEffect(() => {
    if (!q) {
      setItems([])
      setFailed(false)
      setLoading(false)
      return
    }
    // Пока идёт запрос, список предыдущих результатов сбрасываем: иначе
    // переход на новый запрос выглядит как «ничего не нашлось», хотя на самом
    // деле просто ещё грузится.
    let cancelled = false
    setLoading(true)
    setFailed(false)
    setItems([])
    userService.search(q)
      .then((data) => {
        if (!cancelled) setItems(data.data)
      })
      .catch(() => {
        // Отдельно от пустого результата: молчаливый пустой список выглядит
        // как «поиск ничего не нашёл», и пользователь ищет запрос не в том виде.
        if (!cancelled) setFailed(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      // Ответ на уже отменённый запрос игнорируем: при быстрых повторных
      // вводах сервер может ответить не в том порядке, в котором спрашивали.
      cancelled = true
    }
  }, [q])

  // Отступы и белая подложка принадлежат ClientLayout, страница их не дублирует.
  const renderBody = () => {
    if (loading) {
      return <Spin/>
    }
    if (failed) {
      return <Typography.Text type="secondary">Не удалось выполнить поиск, попробуйте позже</Typography.Text>
    }
    if (q && items.length === 0) {
      return <Typography.Text type="secondary">Ничего не найдено по запросу «{q}»</Typography.Text>
    }
    return <ResearchListComponent items={items}/>
  }

  return (
        <>
          <Typography.Title>Поиск</Typography.Title>
          {renderBody()}
        </>
  )
}

export default SearchPage
